import { useContext, useEffect, useState } from "react";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import { encodeQueryParams } from "../../../../../utils/EncodeDecodeQueryParams";
import { useLocation, useNavigate } from "react-router-dom";

export const useAPIGetSelesai = (props) => {
  const uiContext = useContext(UiContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { filterValue } = props;

  const { requestGet, requestDelete, loading } = useAPIRequest();

  const [paging, setPaging] = useState({
    page: 1,
    take: 10,
    filter: "",
    total: 0,
  });
  const [listDataSelesai, setListDataSelesai] = useState([]);

  //  API call section

  const fetchListSelesai = async ({
    page = 1,
    take = 10,
    filter,
    filterValue: _filterValue,
  }) => {
    const _filter =
      (filter ?? getFilter(_filterValue)) +
      `;tanggal_transaksi:!=:Null;data_kendaraan.data_kendaraan_jenis.nama:!=:Trado`;

    return requestGet({
      fullUrl: `/api/pemakaian/pemakaianmobil/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: "tanggal_transaksi",
        order_method: "DESC",
        with_pemakai: 1,
        with_kendaraan: 1,
        with_supir: 1,
        with_supir_pulang: 1,
        with_tujuan: 1,
      },
      onSuccess: async ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListDataSelesai(
          data.map((item, index) => ({
            ...item,
            no: (page - 1) * take + index + 1,
          }))
        );
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async ({ id }) => {
    return requestDelete({
      fullUrl: "/api/pemakaian/pemakaianmobil/delete",
      ids: [id],
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
      onSuccess: ({ message, data }) => {
        const newListData = listDataSelesai.filter((item) => item.id !== id);
        newListData.forEach((item, index) => {
          item.no = (paging.page - 1) * paging.take + index + 1;
        });
        setListDataSelesai(newListData);

        uiContext.showSuccessMsg("Success", message);
      },
    });
  };

  // other function section

  const getFilter = (filterValueInput) => {
    const filters = [];

    const _filterValue = filterValueInput ?? filterValue;

    if (_filterValue) {
      if (_filterValue.dari) {
        filters.push(
          `tanggal_transaksi:>=:${format(
            _filterValue.dari,
            "yyyy-MM-dd"
          )} 00:00:00`
        );
      }

      if (_filterValue.sampai) {
        filters.push(
          `tanggal_transaksi:<=:${format(
            _filterValue.sampai,
            "yyyy-MM-dd"
          )} 23:59:59`
        );
      }

      filters.push(`tanggal_pulang:!=:Null;tanggal_berangkat:!=:Null`);
      // if (filterDate !== "") {
      //   if (filterDate.includes(";")) {
      //     filterDate =
      //       filterDate.replaceAll(";", `||tanggal_pulang:=:Null;`) +
      //       `||tanggal_pulang:=:Null`;
      //   }
      //   filters.push(filterDate);
      // }

      if (_filterValue.data_kendaraan && _filterValue.data_kendaraan.id > 0) {
        filters.push(`kendaraan_id:=:${_filterValue.data_kendaraan.id}`);
      }
    }

    // const filterKendaraan = convertObjectToAPIFilter({
    //   field: "kendaraan_id",
    //   value: _filterValue.kendaraan,
    //   valueField: "id",
    // });
    // if (filterKendaraan !== "") filters.push(filterKendaraan);

    // filters.push("tanggal_pulang:!=:Null");

    return filters.join(";");
  };

  //   hanlde ui event section

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListSelesai({
      page: newPage,
      take: newTake,
      filter: paging.filter,
    });
  };

  return {
    loading,
    paging,
    fetchListSelesai,
    deleteData,
    listDataSelesai,
    handleOnPage,
  };
};
